// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var DateUtils = require("../../../shared/src/DateUtils.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var GraphQL_PPX = require("@reasonml-community/graphql-ppx/bucklescript/GraphQL_PPX.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var GraphqlHelpers = require("../../../shared/src/GraphqlHelpers.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var CommonTypes_Shift = require("../../../shared/src/types/CommonTypes_Shift.bs.js");
var Interface$BsBastet = require("bs-bastet/bastet/src/Interface.bs.js");
var CommonTypes_Timezone = require("../../../shared/src/types/CommonTypes_Timezone.bs.js");
var WebTypes_WorkerShift = require("./WebTypes_WorkerShift.bs.js");
var CommonTypes_ShiftType = require("../../../shared/src/types/CommonTypes_ShiftType.bs.js");
var CommonTypes_WorkerMessage = require("../../../shared/src/types/CommonTypes_WorkerMessage.bs.js");
var CommonTypes_Shift_DressCode = require("../../../shared/src/types/CommonTypes_Shift_DressCode.bs.js");
var CommonTypes_Business_Location = require("../../../shared/src/types/business/CommonTypes_Business_Location.bs.js");
var CommonTypes_Shift_Accessories = require("../../../shared/src/types/CommonTypes_Shift_Accessories.bs.js");
var CommonTypes_Shift_OnsiteManager = require("../../../shared/src/types/CommonTypes_Shift_OnsiteManager.bs.js");
var CommonTypes_Shift_TipsPayoutType = require("../../../shared/src/types/CommonTypes_Shift_TipsPayoutType.bs.js");
var CommonTypes_Business_Location_ParkingCost = require("../../../shared/src/types/business/CommonTypes_Business_Location_ParkingCost.bs.js");

var Raw = {};

var query = "fragment WebTypes_Shift on Shift   {\n...CommonTypes_Shift_Accessories   \nattire  \nbusiness  {\nbusinessName  \nid  \nusersByProfileableId(first: 1, filter: {profileableType: {equalTo: \"Business\"}})  {\nnodes  {\ncity  {\nid  \ntimezone  \n}\n\n}\n\n}\n\n}\n\nbusinessRateCents  \ncancelledAt  \ncomment  \ndescription  \ndressCode  \nendDatetime  \nhourlyRateCents  \nid  \nlocation  {\n...CommonTypes_Business_Location   \n}\n\nnumberOfWorkers  \noriginalNumberOfWorkers  \n...CommonTypes_Shift_OnsiteManager   \nparkingCost  \nparkingInstructions  \nstartDatetime  \nshiftType  {\n...CommonTypes_ShiftType   \n}\n\ntipsPayoutType  \nworkerMessages(filter: {messageType: {equalTo: 5}}, first: 1)  {\nnodes  {\nuniqueCode  \n}\n\n}\n\nworkerRateCents  \nworkerShifts(filter: {canceledAt: {isNull: true}})  {\nnodes  {\n...WebTypes_WorkerShift   \n}\n\n}\n\n}\n" + CommonTypes_Business_Location.query + CommonTypes_ShiftType.query + CommonTypes_Shift_Accessories.query + CommonTypes_Shift_OnsiteManager.query + WebTypes_WorkerShift.query;

function parse(value) {
  var value$1 = value["attire"];
  var value$2 = value["business"];
  var value$3 = value$2.usersByProfileableId;
  var value$4 = value$3.nodes;
  var value$5 = value["cancelledAt"];
  var value$6 = value["comment"];
  var value$7 = value["description"];
  var value$8 = value["dressCode"];
  var tmp;
  switch (value$8) {
    case "BLACK_ON_BLACK" :
        tmp = "BLACK_ON_BLACK";
        break;
    case "CUSTOM" :
        tmp = "CUSTOM";
        break;
    case "WHITE_ON_BLACK" :
        tmp = "WHITE_ON_BLACK";
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$8
      };
  }
  var value$9 = value["location"];
  var value$10 = value["originalNumberOfWorkers"];
  var value$11 = value["parkingCost"];
  var tmp$1;
  switch (value$11) {
    case "FEE_NOT_REIMBURSED" :
        tmp$1 = "FEE_NOT_REIMBURSED";
        break;
    case "FEE_REIMBURSED" :
        tmp$1 = "FEE_REIMBURSED";
        break;
    case "FREE" :
        tmp$1 = "FREE";
        break;
    case "PARKING_INFO_NOT_PROVIDED" :
        tmp$1 = "PARKING_INFO_NOT_PROVIDED";
        break;
    default:
      tmp$1 = {
        NAME: "FutureAddedValue",
        VAL: value$11
      };
  }
  var value$12 = value["shiftType"];
  var value$13 = value["tipsPayoutType"];
  var tmp$2;
  switch (value$13) {
    case "NO_TIPS" :
        tmp$2 = "NO_TIPS";
        break;
    case "TIPS_PAID_BY_QWICK" :
        tmp$2 = "TIPS_PAID_BY_QWICK";
        break;
    case "TIPS_PAID_IN_CASH" :
        tmp$2 = "TIPS_PAID_IN_CASH";
        break;
    default:
      tmp$2 = {
        NAME: "FutureAddedValue",
        VAL: value$13
      };
  }
  var value$14 = value["workerMessages"];
  var value$15 = value$14.nodes;
  var value$16 = value["workerShifts"];
  var value$17 = value$16.nodes;
  return {
          commonTypes_Shift_Accessories: CommonTypes_Shift_Accessories.verifyArgsAndParse("CommonTypes_Shift_Accessories", value),
          attire: !(value$1 == null) ? value$1 : undefined,
          business: {
            businessName: value$2.businessName,
            id: value$2.id,
            usersByProfileableId: {
              nodes: value$4.map(function (value) {
                    if (value == null) {
                      return ;
                    }
                    var value$1 = value.city;
                    return {
                            city: {
                              id: value$1.id,
                              timezone: CommonTypes_Timezone.GraphQL_API.parse(value$1.timezone)
                            }
                          };
                  })
            }
          },
          businessRateCents: value["businessRateCents"],
          cancelledAt: !(value$5 == null) ? Caml_option.some(GraphqlHelpers.Datetime.parse(value$5)) : undefined,
          comment: !(value$6 == null) ? value$6 : undefined,
          description: !(value$7 == null) ? value$7 : undefined,
          dressCode: tmp,
          endDatetime: GraphqlHelpers.Datetime.parse(value["endDatetime"]),
          hourlyRateCents: value["hourlyRateCents"],
          id: Curry._1(CommonTypes_Shift.Id.GraphQL_API.parse, value["id"]),
          location: CommonTypes_Business_Location.verifyArgsAndParse("CommonTypes_Business_Location", value$9),
          numberOfWorkers: value["numberOfWorkers"],
          originalNumberOfWorkers: !(value$10 == null) ? value$10 : undefined,
          commonTypes_Shift_OnsiteManager: CommonTypes_Shift_OnsiteManager.verifyArgsAndParse("CommonTypes_Shift_OnsiteManager", value),
          parkingCost: tmp$1,
          parkingInstructions: value["parkingInstructions"],
          startDatetime: GraphqlHelpers.Datetime.parse(value["startDatetime"]),
          shiftType: CommonTypes_ShiftType.verifyArgsAndParse("CommonTypes_ShiftType", value$12),
          tipsPayoutType: tmp$2,
          workerMessages: {
            nodes: value$15.map(function (value) {
                  if (!(value == null)) {
                    return {
                            uniqueCode: Curry._1(CommonTypes_WorkerMessage.UniqueCode.GraphQL_API.parse, value.uniqueCode)
                          };
                  }
                  
                })
          },
          workerRateCents: value["workerRateCents"],
          workerShifts: {
            nodes: value$17.map(function (value) {
                  if (!(value == null)) {
                    return WebTypes_WorkerShift.verifyArgsAndParse("WebTypes_WorkerShift", value);
                  }
                  
                })
          }
        };
}

function serialize(value) {
  var value$1 = value.workerShifts;
  var value$2 = value$1.nodes;
  var nodes = value$2.map(function (value) {
        if (value !== undefined) {
          return WebTypes_WorkerShift.serialize(value);
        } else {
          return null;
        }
      });
  var workerShifts = {
    nodes: nodes
  };
  var value$3 = value.workerRateCents;
  var value$4 = value.workerMessages;
  var value$5 = value$4.nodes;
  var nodes$1 = value$5.map(function (value) {
        if (value === undefined) {
          return null;
        }
        var value$1 = value.uniqueCode;
        var value$2 = Curry._1(CommonTypes_WorkerMessage.UniqueCode.GraphQL_API.serialize, value$1);
        return {
                uniqueCode: value$2
              };
      });
  var workerMessages = {
    nodes: nodes$1
  };
  var value$6 = value.tipsPayoutType;
  var tipsPayoutType = typeof value$6 === "string" ? (
      value$6 === "TIPS_PAID_IN_CASH" ? "TIPS_PAID_IN_CASH" : (
          value$6 === "NO_TIPS" ? "NO_TIPS" : "TIPS_PAID_BY_QWICK"
        )
    ) : value$6.VAL;
  var value$7 = value.shiftType;
  var shiftType = CommonTypes_ShiftType.serialize(value$7);
  var value$8 = value.startDatetime;
  var value$9 = Curry._1(GraphqlHelpers.Datetime.serialize, value$8);
  var value$10 = value.parkingInstructions;
  var value$11 = value.parkingCost;
  var parkingCost = typeof value$11 === "string" ? (
      value$11 === "FEE_REIMBURSED" ? "FEE_REIMBURSED" : (
          value$11 === "PARKING_INFO_NOT_PROVIDED" ? "PARKING_INFO_NOT_PROVIDED" : (
              value$11 === "FREE" ? "FREE" : "FEE_NOT_REIMBURSED"
            )
        )
    ) : value$11.VAL;
  var value$12 = value.originalNumberOfWorkers;
  var originalNumberOfWorkers = value$12 !== undefined ? value$12 : null;
  var value$13 = value.numberOfWorkers;
  var value$14 = value.location;
  var $$location = CommonTypes_Business_Location.serialize(value$14);
  var value$15 = value.id;
  var value$16 = Curry._1(CommonTypes_Shift.Id.GraphQL_API.serialize, value$15);
  var value$17 = value.hourlyRateCents;
  var value$18 = value.endDatetime;
  var value$19 = Curry._1(GraphqlHelpers.Datetime.serialize, value$18);
  var value$20 = value.dressCode;
  var dressCode = typeof value$20 === "string" ? (
      value$20 === "BLACK_ON_BLACK" ? "BLACK_ON_BLACK" : (
          value$20 === "CUSTOM" ? "CUSTOM" : "WHITE_ON_BLACK"
        )
    ) : value$20.VAL;
  var value$21 = value.description;
  var description = value$21 !== undefined ? value$21 : null;
  var value$22 = value.comment;
  var comment = value$22 !== undefined ? value$22 : null;
  var value$23 = value.cancelledAt;
  var cancelledAt = value$23 !== undefined ? Curry._1(GraphqlHelpers.Datetime.serialize, Caml_option.valFromOption(value$23)) : null;
  var value$24 = value.businessRateCents;
  var value$25 = value.business;
  var value$26 = value$25.usersByProfileableId;
  var value$27 = value$26.nodes;
  var nodes$2 = value$27.map(function (value) {
        if (value === undefined) {
          return null;
        }
        var value$1 = value.city;
        var value$2 = value$1.timezone;
        var value$3 = Curry._1(CommonTypes_Timezone.GraphQL_API.serialize, value$2);
        var value$4 = value$1.id;
        var city = {
          id: value$4,
          timezone: value$3
        };
        return {
                city: city
              };
      });
  var usersByProfileableId = {
    nodes: nodes$2
  };
  var value$28 = value$25.id;
  var value$29 = value$25.businessName;
  var business = {
    businessName: value$29,
    id: value$28,
    usersByProfileableId: usersByProfileableId
  };
  var value$30 = value.attire;
  var attire = value$30 !== undefined ? value$30 : null;
  return [
            CommonTypes_Shift_Accessories.serialize(value.commonTypes_Shift_Accessories),
            CommonTypes_Shift_OnsiteManager.serialize(value.commonTypes_Shift_OnsiteManager)
          ].reduce(GraphQL_PPX.deepMerge, {
              attire: attire,
              business: business,
              businessRateCents: value$24,
              cancelledAt: cancelledAt,
              comment: comment,
              description: description,
              dressCode: dressCode,
              endDatetime: value$19,
              hourlyRateCents: value$17,
              id: value$16,
              location: $$location,
              numberOfWorkers: value$13,
              originalNumberOfWorkers: originalNumberOfWorkers,
              parkingCost: parkingCost,
              parkingInstructions: value$10,
              startDatetime: value$9,
              shiftType: shiftType,
              tipsPayoutType: tipsPayoutType,
              workerMessages: workerMessages,
              workerRateCents: value$3,
              workerShifts: workerShifts
            });
}

function verifyArgsAndParse(_WebTypes_Shift, value) {
  return parse(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  var match = param.business;
  var match$1 = match.usersByProfileableId.nodes;
  var businessName = match.businessName;
  var attire = param.attire;
  var accessories = param.commonTypes_Shift_Accessories;
  if (match$1.length !== 1) {
    return ;
  }
  var match$2 = match$1[0];
  if (match$2 === undefined) {
    return ;
  }
  var description = param.description;
  if (description === undefined) {
    return ;
  }
  var originalNumberOfWorkers = param.originalNumberOfWorkers;
  if (originalNumberOfWorkers === undefined) {
    return ;
  }
  var match$3 = param.workerMessages.nodes;
  if (match$3.length !== 1) {
    return ;
  }
  var tipsPayoutType = param.tipsPayoutType;
  var shiftType = param.shiftType;
  var startDatetime = param.startDatetime;
  var parkingInstructions = param.parkingInstructions;
  var parkingCost = param.parkingCost;
  var numberOfWorkers = param.numberOfWorkers;
  var $$location = param.location;
  var id = param.id;
  var hourlyRateCents = param.hourlyRateCents;
  var endDatetime = param.endDatetime;
  var dressCode = param.dressCode;
  var comment = param.comment;
  var cancelledAt = param.cancelledAt;
  var businessRateCents = param.businessRateCents;
  var timezone = match$2.city.timezone;
  var match$4 = match$3[0];
  if (match$4 === undefined) {
    return ;
  }
  var workerShifts = param.workerShifts.nodes;
  var workerRateCents = param.workerRateCents;
  var ratingMessageUniqueCode = match$4.uniqueCode;
  return Relude_Option.map((function (onsiteManager) {
                return {
                        accessories: CommonTypes_Shift_Accessories.tToR(accessories),
                        attire: Relude_Option.getOrElse("", attire),
                        businessName: businessName,
                        businessRateCents: businessRateCents,
                        cancelledAt: cancelledAt,
                        comment: comment,
                        description: description,
                        dressCode: CommonTypes_Shift_DressCode.parseApiResponse(dressCode),
                        endDatetime: endDatetime,
                        hourlyRateCents: hourlyRateCents,
                        id: id,
                        location: CommonTypes_Business_Location.tToR($$location),
                        numberOfWorkers: numberOfWorkers,
                        onsiteManager: onsiteManager,
                        originalNumberOfWorkers: originalNumberOfWorkers,
                        parkingCost: CommonTypes_Business_Location_ParkingCost.parseApiResponse(parkingCost),
                        parkingInstructions: parkingInstructions,
                        ratingMessageUniqueCode: ratingMessageUniqueCode,
                        shiftType: CommonTypes_ShiftType.tToR(shiftType),
                        startDatetime: startDatetime,
                        timezone: timezone,
                        tipsPayoutType: CommonTypes_Shift_TipsPayoutType.parseApiResponse(tipsPayoutType),
                        workerRateCents: workerRateCents,
                        workerShifts: Relude_Array.mapOption(Curry._1(Relude_Option.flatMap, WebTypes_WorkerShift.tToR), workerShifts)
                      };
              }), CommonTypes_Shift_OnsiteManager.tToR(param.commonTypes_Shift_OnsiteManager));
}

function compareByStartDatetime(param, param$1) {
  return Relude_Function.curry2((function (param) {
                var match = param[1];
                var bStart = match.startDatetime;
                var match$1 = param[0];
                var aStart = match$1.startDatetime;
                if (DateUtils.eq(undefined, undefined, aStart, bStart)) {
                  return Curry._2(CommonTypes_Shift.Id.compare, match$1.id, match.id);
                } else {
                  return Interface$BsBastet.invert(Curry._2(DateUtils.compare(undefined, undefined), aStart, bStart));
                }
              }), param, param$1);
}

function compare(param, param$1) {
  return Curry._2(CommonTypes_Shift.Id.compare, param.id, param$1.id);
}

function eq(param, param$1) {
  return Curry._2(CommonTypes_Shift.Id.eq, param.id, param$1.id);
}

var Ord = {
  compare: compare,
  eq: eq
};

var $$Map = Relude_Map.WithOrd({
      eq: eq,
      compare: compare
    });

var $$Set = Relude_Set.WithOrd({
      eq: eq,
      compare: compare
    });

function canBusinessCancelShift(currentDatetime, param) {
  return CommonTypes_Shift.canBusinessCancelShift(currentDatetime, param.cancelledAt, param.startDatetime);
}

function canBusinessEditShift(currentDatetime, param) {
  return CommonTypes_Shift.canBusinessEditShift(currentDatetime, param.cancelledAt, param.startDatetime);
}

exports.Raw = Raw;
exports.query = query;
exports.parse = parse;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
exports.compareByStartDatetime = compareByStartDatetime;
exports.compare = compare;
exports.eq = eq;
exports.Ord = Ord;
exports.$$Map = $$Map;
exports.$$Set = $$Set;
exports.canBusinessCancelShift = canBusinessCancelShift;
exports.canBusinessEditShift = canBusinessEditShift;
/* Map Not a pure module */
